// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  ControllerInfoContent,
  unionToControllerInfoContent,
  unionListToControllerInfoContent,
} from "./controller-info-content";
import {
  ControllerLabelsMessage,
  ControllerLabelsMessageT,
  verifyControllerLabelsMessage,
} from "./controller-labels-message";
import {
  ControllerVersionInfoMessage,
  ControllerVersionInfoMessageT,
  verifyControllerVersionInfoMessage,
} from "./controller-version-info-message";
import {
  DispatcherVersionMessage,
  DispatcherVersionMessageT,
  verifyDispatcherVersionMessage,
} from "./dispatcher-version-message";
import {
  FirmwareVersionMessage,
  FirmwareVersionMessageT,
  verifyFirmwareVersionMessage,
} from "./firmware-version-message";
import {
  FloorLabelMessage,
  FloorLabelMessageT,
  verifyFloorLabelMessage,
} from "./floor-label-message";
import {
  FloorLabelsDataMessage,
  FloorLabelsDataMessageT,
  verifyFloorLabelsDataMessage,
} from "./floor-labels-data-message";
import {
  FloorPhysicalOpeningsMessage,
  FloorPhysicalOpeningsMessageT,
  verifyFloorPhysicalOpeningsMessage,
} from "./floor-physical-openings-message";
import {
  HallCallEligibilityMessage,
  HallCallEligibilityMessageT,
  verifyHallCallEligibilityMessage,
} from "./hall-call-eligibility-message";
import { JobNameMessage, JobNameMessageT, verifyJobNameMessage } from "./job-name-message";
import {
  ShuttleFloorsMessage,
  ShuttleFloorsMessageT,
  verifyShuttleFloorsMessage,
} from "./shuttle-floors-message";

export class NormalControllerInfo implements flatbuffers.IUnpackableObject<NormalControllerInfoT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalControllerInfo {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalControllerInfo(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalControllerInfo,
  ): NormalControllerInfo {
    return (obj || new NormalControllerInfo()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsNormalControllerInfo(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalControllerInfo,
  ): NormalControllerInfo {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalControllerInfo()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  messageType(): ControllerInfoContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ControllerInfoContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startNormalControllerInfo(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: ControllerInfoContent) {
    builder.addFieldInt8(0, messageType, ControllerInfoContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endNormalControllerInfo(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createNormalControllerInfo(
    builder: flatbuffers.Builder,
    messageType: ControllerInfoContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    NormalControllerInfo.startNormalControllerInfo(builder);
    NormalControllerInfo.addMessageType(builder, messageType);
    NormalControllerInfo.addMessage(builder, messageOffset);
    return NormalControllerInfo.endNormalControllerInfo(builder);
  }

  unpack(): NormalControllerInfoT {
    return new NormalControllerInfoT(
      this.messageType(),
      (() => {
        const temp = unionToControllerInfoContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: NormalControllerInfoT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToControllerInfoContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): NormalControllerInfoT {
    const t = new NormalControllerInfoT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToControllerInfoContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class NormalControllerInfoT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: ControllerInfoContent = ControllerInfoContent.NONE,
    public message:
      | ControllerLabelsMessageT
      | ControllerVersionInfoMessageT
      | DispatcherVersionMessageT
      | FirmwareVersionMessageT
      | FloorLabelMessageT
      | FloorLabelsDataMessageT
      | FloorPhysicalOpeningsMessageT
      | HallCallEligibilityMessageT
      | JobNameMessageT
      | ShuttleFloorsMessageT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return NormalControllerInfo.createNormalControllerInfo(builder, this.messageType, message);
  }

  clone(): NormalControllerInfoT {
    const obj = new NormalControllerInfoT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: NormalControllerInfoT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalControllerInfo(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // FloorLabelMessage
            {
              const o = verifier.readInt32(pos);
              verifyFloorLabelMessage(verifier, pos + o);
            }
            break;
          case 2: // FirmwareVersionMessage
            {
              const o = verifier.readInt32(pos);
              verifyFirmwareVersionMessage(verifier, pos + o);
            }
            break;
          case 3: // ControllerLabelsMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerLabelsMessage(verifier, pos + o);
            }
            break;
          case 4: // FloorLabelsDataMessage
            {
              const o = verifier.readInt32(pos);
              verifyFloorLabelsDataMessage(verifier, pos + o);
            }
            break;
          case 5: // DispatcherVersionMessage
            {
              const o = verifier.readInt32(pos);
              verifyDispatcherVersionMessage(verifier, pos + o);
            }
            break;
          case 6: // ControllerVersionInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerVersionInfoMessage(verifier, pos + o);
            }
            break;
          case 7: // JobNameMessage
            {
              const o = verifier.readInt32(pos);
              verifyJobNameMessage(verifier, pos + o);
            }
            break;
          case 8: // FloorPhysicalOpeningsMessage
            {
              const o = verifier.readInt32(pos);
              verifyFloorPhysicalOpeningsMessage(verifier, pos + o);
            }
            break;
          case 9: // HallCallEligibilityMessage
            {
              const o = verifier.readInt32(pos);
              verifyHallCallEligibilityMessage(verifier, pos + o);
            }
            break;
          case 10: // ShuttleFloorsMessage
            {
              const o = verifier.readInt32(pos);
              verifyShuttleFloorsMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
